import { z } from 'zod';
import { SchemaFormDefinition, SchemaFormFields } from '@mews-commander/form';
import { Option } from '@mews-commander/types';
import { lt } from '@mews/framework';
import { TEMPLATE_STATUS_OPTIONS } from './constants';

export enum TemplatesTableFilterSchemaKeys {
    Name = 'name',
    Service = 'service',
    Status = 'status',
}

export const templatesTableFilterSchema = z
    .object({
        [TemplatesTableFilterSchemaKeys.Name]: z.string().optional(),
        [TemplatesTableFilterSchemaKeys.Service]: z.array(z.string()).optional(),
        [TemplatesTableFilterSchemaKeys.Status]: z.array(z.string()).optional(),
    })
    .partial();

export type TemplatesTableFilterValues = z.infer<typeof templatesTableFilterSchema>;

const templatesTableFiltersFormDefinition = ({
    serviceOptions,
}: {
    serviceOptions?: Option[];
}): SchemaFormDefinition<typeof templatesTableFilterSchema> => ({
    fields: {
        name: {
            label: lt('ContractTemplateNameLabel'),
            field: { clearable: true, type: 'text' },
        },
        service: {
            label: lt('Service'),
            field: {
                type: 'select',
                options: serviceOptions ?? [],
                showEmptyValue: false,
            },
        },
        status: {
            label: lt('Status'),
            field: {
                type: 'select',
                options: TEMPLATE_STATUS_OPTIONS,
                showEmptyValue: false,
            },
        },
    },
});

export const TemplatesTableFiltersForm = ({ serviceOptions }: { serviceOptions?: Option[] }) => (
    <SchemaFormFields
        schema={templatesTableFilterSchema}
        formDefinition={templatesTableFiltersFormDefinition({ serviceOptions })}
    />
);
